module.exports = __webpack_public_path__ + "static/img/akum_200.89af921.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akum_200.svg
// module id = UC7d
// module chunks = 1